export default __webpack_public_path__ + "static/media/background-marketplace.28c39de9.png";